import React, { type FC } from 'react';
import { Avatar, Card, Divider, Flex, Statistic } from 'antd';
import { CheckOutlined, DoubleRightOutlined } from '@ant-design/icons';
import { gold, green } from '@ant-design/colors';
import { Space } from '@g2u/ui-kit';
import './summary-item.component';

import { Section } from 'components';

import { useTaskSummary } from '../../hooks/useTaskSummary';
import { SummaryItem } from './summary-item.component';
import styles from './geektasks.module.scss';

export namespace GeekTasks {
  export const $: FC = () => {
    const { summary, isLoading } = useTaskSummary();
    const { pending, complete, overdue, withinOneHour, overOneHour } = summary || {};

    return (
      <Section.$ full className={styles.geektasks}>
        <Flex vertical gap='middle' flex={1}>
          <Card.Meta title="My GeekTasks Today" />
          <Card type="inner" style={{ flexGrow: 1 }}>
            <Flex gap="middle">
              <Avatar icon={<DoubleRightOutlined />} shape="square" style={{ backgroundColor: gold[5] }} />
              <Space.$ direction={Space.Direction.Vertical} size={Space.Size.Middle} fullWidth>
                <Statistic title="Pending GeekTasks" loading={isLoading} value={pending} />
                <Divider style={{ margin: 0 }} />
                <SummaryItem color="red" name="Overdue" data={overdue} />
                <SummaryItem color="orange" name="Due - Within 1 Hour" data={withinOneHour} />
                <SummaryItem color="blue" name="Due - Over 1 Hour" data={overOneHour} />
              </Space.$>
            </Flex>
          </Card>
          <Card type="inner">
            <Flex gap="middle">
              <Avatar icon={<CheckOutlined />} shape="square" style={{ backgroundColor: green[5] }} />
              <Statistic title="Done GeekTasks" loading={isLoading} value={complete} />
            </Flex>
          </Card>
        </Flex>
      </Section.$>
    );
  };
}
